// Common helper functions for file downloads and other utilities
// downloadFileFromBase64 is defined in downloads.js. Don't redefine it here: both files are
// bundled alphabetically, so this one would silently override it.

window.downloadFileFromUrl = function (filename, url) {
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = filename;
    downloadLink.click();
};

window.dataFilesModal = window.dataFilesModal || {};

window.dataFilesModal.setRadioChecked = function (csvId, excelId, isCsvSelected) {
    try {
        const csvRadio = document.getElementById(csvId);
        const excelRadio = document.getElementById(excelId);

        if (csvRadio) csvRadio.checked = !!isCsvSelected;
        if (excelRadio) excelRadio.checked = !isCsvSelected;
    } catch {
        // ignore
    }
};
